import { color } from "@app/theme/weaveTokens.ts";

/**
 * The app's MUI palette, built from Weave tokens with the Digital HIG values.
 *
 * Weave legacy styles components directly and leaves `palette` at MUI's
 * defaults, so anything reading it changed: `<Switch color="success">`, error
 * helper text, default `primary` (blue instead of black) and input text
 * (`text.primary` at 0.87 alpha). `urgency`, `attention` and `neutral` are not
 * set because nothing in the app reads them.
 *
 * `error.main` and `success.main` keep the DHIG colours, not Weave's semantic
 * status colours. DEVX-11164 (XD question). `text.secondary` is white, as it
 * was in the DHIG theme.
 */
export const appPalette = {
  mode: "light" as const,
  common: { black: color.black, white: color.white },
  primary: { main: color.black },
  error: { main: color.error },
  success: { main: color.success },
  text: { primary: color.black, secondary: color.white },
  divider: color.rowDivider,
  background: { paper: color.surface, default: color.surface },
};
